import React from 'react'
import { Box, Button, CircularProgress, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import AddIcon from '@material-ui/icons/Add'
import MaterialComparisonCard from './MaterialComparisonCard'

const PAGE_SIZE = 20

const useStyles = makeStyles(() => ({
  '@keyframes scaleIn': {
    from: { opacity: 0, transform: 'scale(0.97)' },
    to: { opacity: 1, transform: 'scale(1)' }
  },
  cardWrapper: {
    animation: '$scaleIn 0.25s ease forwards',
    opacity: 0
  },
  emptyCard: {
    background: 'var(--surface)',
    border: '1px solid var(--line)',
    borderRadius: 'var(--r-lg)',
    padding: '48px 24px',
    textAlign: 'center'
  },
  emptyTitle: {
    fontFamily: 'var(--font-ui)',
    fontSize: 15,
    fontWeight: 600,
    color: 'var(--ink)',
    marginBottom: 6
  },
  emptySubtext: {
    fontFamily: 'var(--font-ui)',
    fontSize: 13,
    color: 'var(--ink-3)',
    marginBottom: 16
  },
  paginationBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 16,
    paddingBottom: 8
  },
  paginationText: {
    fontFamily: 'var(--font-mono)',
    fontSize: 12,
    color: 'var(--ink-4)'
  }
}))

export default function ComparisonGrid ({ data, loading, total, page, onPageChange, onOpenCalc, onOpenCreate }) {
  const classes = useStyles()

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" pt={8} pb={8}>
        <CircularProgress size={32} />
      </Box>
    )
  }

  if (!data || data.length === 0) {
    return (
      <div className={classes.emptyCard}>
        <p className={classes.emptyTitle}>No materials match the current filters.</p>
        <p className={classes.emptySubtext}>Try broadening your search or adding offerings.</p>
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={() => onOpenCreate(null, null)}
          style={{ color: 'var(--primary)', borderColor: 'var(--primary)' }}
        >
          Add Offering
        </Button>
      </div>
    )
  }

  const startRow = page * PAGE_SIZE + 1
  const endRow = page * PAGE_SIZE + data.length
  const hasPrev = page > 0
  const hasNext = data.length === PAGE_SIZE

  return (
    <>
      {data.map((group, index) => (
        <div
          key={`${group.materialProfile?._id || 'unk'}-${group.gradation?._id || 'none'}`}
          className={classes.cardWrapper}
          style={{ animationDelay: `${index * 0.04}s` }}
        >
          <MaterialComparisonCard
            group={group}
            onOpenCalc={onOpenCalc}
            onOpenCreate={onOpenCreate}
          />
        </div>
      ))}

      {/* Pagination footer */}
      <div className={classes.paginationBar}>
        <span className={classes.paginationText}>
          Showing {startRow}\u2013{endRow}{total > 0 ? ` of ${total}` : ''}
        </span>
        <IconButton size="small" onClick={() => onPageChange(page - 1)} disabled={!hasPrev}>
          <NavigateBeforeIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => onPageChange(page + 1)} disabled={!hasNext}>
          <NavigateNextIcon fontSize="small" />
        </IconButton>
      </div>
    </>
  )
}
